import DOMPurify from 'dompurify'

// Same policy as config/helpers/staticPages/sanitize.js: keep CMS formatting, drop active content.
const PURIFY_CONFIG = {
	FORBID_TAGS: ['style', 'form', 'iframe', 'object', 'embed', 'link', 'meta', 'base'],
	ADD_ATTR: ['target'],
}

DOMPurify.addHook('afterSanitizeAttributes', (node) => {
	if (node.tagName === 'A' && node.getAttribute('target') === '_blank') node.setAttribute('rel', 'noopener noreferrer')
})

export function safeHtml(value) {
	if (value === null || value === undefined) return ''
	return DOMPurify.sanitize(String(value), PURIFY_CONFIG)
}

// Drop-in replacement for v-html: <div v-safe-html="html" />
export const vSafeHtml = {
	mounted(el, binding) {
		el.innerHTML = safeHtml(binding.value)
	},
	updated(el, binding) {
		if (binding.value !== binding.oldValue) el.innerHTML = safeHtml(binding.value)
	},
}
